import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import { ManagementLogin } from './ManagementLogin';
import { LoginDataType } from './DataFetch/ManagementAPI';
import { Management } from './Management';
import { GetConfirmSession, PostDeleteSession, RemoveSessionID } from './Utility/SessionUtility';

/**
 * ログイン情報を受け渡すContext
 */
export const LoginDataContext = React.createContext<LoginDataType | undefined>({} as LoginDataType | undefined);

/**
 * セッション確認関数を受け渡すContext
 */
export const SessionContext = React.createContext<() => Promise<boolean>>(() => new Promise<boolean>(() => false));

/**
 * 管理画面ルートコンポーネント
 */
export function ManagementRoot() {

    /**
     * セッション確認中フラグ
     * ロード時のみtrue、確認後はfaise
     */
    const [isConfirming, setIsConfirming] = useState(true);

    /**
     * ログインフラグ
     * ログイン成功、またはセッション継続が確認されたらtrue
     */
    const [logined, setLogined] = useState<boolean>(false);

    /**
     * ログイン時に取得するデータを保持
     * ログアウトしたらundefinedに設定
     */
    const [loginData, setLoginData] = useState<LoginDataType | undefined>(undefined);

    /**
     * ロード時にタブ名変更
     */
    useEffect(() => {
        document.title = "KAGU管理"
    },[])

    /**
     * ロード時にセッションの継続確認を行う
     * 継続可ならログイン、不可ならストレージからセッションIDを削除
     */
    useEffect(() => {
        GetConfirmSession()
        .then(res => {
            if (res !== undefined) {
                if(res.session_result) {
                    setLogined(true);
                } else {
                    RemoveSessionID()
                }
            }
            setIsConfirming(false);
        })
    },[])

    /**
     * セッション継続可能か確認する関数
     * 継続不可、またはAPIエラーの場合、ログアウトする
     * Contextによりすべての画面にこの関数を渡し、API実行前にセッション確認を行う
     * @returns セッション継続可能:true 不可:false
     */
    async function ConfirmSession() : Promise<boolean> {
        const result = await GetConfirmSession()
        .then(res => {
            if(res !== undefined) {
                !res?.session_result && Logout(); 
                return res?.session_result;
            } else {
                Logout();
                return false
            }
        })

        return result;
    }

    /**
     * ログアウト処理
     */
    function Logout() {
        // ログインデータ削除
        setLoginData(undefined);
        //ログインフラグを降ろす
        setLogined(false);
        // サーバとストレージからSessionIDを削除
        PostDeleteSession()
        .then(res => {
            res && RemoveSessionID()
        })
    }

    return(
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                }}
            >
                {/* ログインデータとセッション確認関数をContextで全画面に渡す */}
                <LoginDataContext.Provider value={loginData}>
                    <SessionContext.Provider value={ConfirmSession}>
                        {
                            !isConfirming   //ロード時のセッション確認が終わってから画面表示
                            ?
                            logined ? <Management Logout={Logout}/> : <ManagementLogin setLogined={setLogined} setLoginData={setLoginData}/>
                            :
                            ""
                        }
                    </SessionContext.Provider>
                </LoginDataContext.Provider>
            </Box>
        </>
    );
}